import { Instance } from 'mobx-state-tree';
import { RouteSolutionViolationDtoModelBase } from './RouteSolutionViolationDtoModel.base';

/* The TypeScript type of an instance of RouteSolutionViolationDtoModel */
export interface RouteSolutionViolationDtoModelType extends Instance<typeof RouteSolutionViolationDtoModel.Type> {}

/* A graphql query fragment builders for RouteSolutionViolationDtoModel */
export { selectFromRouteSolutionViolationDto, routeSolutionViolationDtoModelPrimitives, RouteSolutionViolationDtoModelSelector } from './RouteSolutionViolationDtoModel.base';

/**
 * RouteSolutionViolationDtoModel
 */
export const RouteSolutionViolationDtoModel = RouteSolutionViolationDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
